import React, { Component } from 'react';
import UA from '../../utils/ua';
import './style.less';
import { myStorage } from '../../utils/tools';

class NASAPay extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.storage = myStorage;
        this.state = {
            channel: Number(this.storage.getItem('user_channel')) || 0,
            inviteAwardIndex: window.user_inviteAwardIndex || 0
        }
    }

    handleClick = index => {
        // const { inviteAwardList } = this.props;
        this.setState({
            inviteAwardIndex: index
        });
        window.user_inviteAwardIndex = index;
    }

    render(){
        const { channel, inviteAwardIndex } = this.state;
        const {
            userAddress,
            coursesInfo,
            inviteAwardList,
            courseId,
            isHasDiscount,
            discountCoupon,
            notUseDiscount,
            isAllowAgreement,
            handleClick,
            agreementSelect,
            clickToAgreement, //跳转至支付协议
        } = this.props;
        const _price = coursesInfo.totalAmount || 0; //原价
        // 有实物赠品显示地址
        const isHaveEntity = inviteAwardList[inviteAwardIndex] ? inviteAwardList[inviteAwardIndex].isHaveEntity : 0;
        let price = _price; //优惠后价格
        if(discountCoupon.couponAmount){
            price = Number(discountCoupon.couponAmount - price) > 0 ? 0 : price - discountCoupon.couponAmount;
        }
        price = price / 100;
        const inviteAwardItem = inviteAwardList.map((ele, index) => {
            return (
                <div className="gift_rows" key={index} onClick={(i) => {this.handleClick(index)}}>
                    <span className="name">{ele.inviteAwardName}</span>
                    <div className={ `status ${inviteAwardIndex === index ? 'active' : ''}` }></div>
                </div>
            )
        })
        return(
            <div className={`container nasapay ${ this.isMobile?'' : 'pc' }`}>
                {coursesInfo.purchaseReminder &&
                    <div className="notice">
                        <div className="icon"></div>
                        <div className="text">{coursesInfo.purchaseReminder}</div>
                    </div>
                }
                {!!isHaveEntity &&
                    <div className="address_wrap" >
                        { userAddress ?
                            <div onClick={ this.props.handleAddress }>
                                <div className="name">{ userAddress.consignee }</div>
                                <div className="tele"> {userAddress.consigneePhone }</div>
                                <div className="address">
                                    {`${userAddress.province} ${userAddress.city} ${userAddress.area} ${userAddress.detail}`}
                                </div>
                            </div>
                            :
                            <div className="address" onClick={ this.props.handleAddress }>请填写收货地址</div>
                        }
                        <div className="go" onClick={ this.props.handleAddress }></div>
                    </div>
                }
                <div className="course_info_wrap">
                    <div className="rows course">
                        <div className="img" style={{ backgroundImage: `url(${coursesInfo.picUrl})` }}></div>
                        <div className="course_info">
                            <div className="title">{ coursesInfo.name }</div>
                            <div className="price">￥{_price/100 - ~~(_price/100)>0?(_price/100).toFixed(2) : _price/100}</div>
                        </div>
                    </div>
                    {!!inviteAwardList.length &&
                        <div className="gift_wrap">
                            {inviteAwardList.length > 1 ?
                                <div className="gift list">
                                    <div className="title">赠品任选其一</div>
                                    {inviteAwardItem}
                                </div>
                                :
                                <div className="gift_rows one">{inviteAwardList[0].inviteAwardName}</div>
                            }
                        </div>
                    }
                </div>
                { !UA.iosClient &&
                    <div className='discount_coupon' onClick={ this.props.handleDiscount }>
                        <div>优惠券</div>
                        <div className={`discount_status ${isHasDiscount ? 'has' : 'notHas'}`}>
                            { !isHasDiscount ? '无可用优惠券' : (notUseDiscount === '1' ? '不使用优惠券' : `-${(Object.keys(discountCoupon).length > 0 && Number(discountCoupon.couponAmount / 100 || 0)) || 0}`) }
                        </div>
                        <div className="go" ></div>
                    </div>
                }
                { !UA.iosClient &&
                    <div className="pay_way_wrap">
                        <div
                            className={ `weixin pay_way` }
                            onClick={ ()=>{
                                    this.setState({channel: 0});
                                    this.storage.removeItem('user_channel');
                                    this.storage.setItem('user_channel', 0);
                                }
                            }
                        >
                            <div className="img"></div>
                            <div className="name">微信支付</div>
                            <div className={ `status ${this.state.channel === 0 ? 'active' : ''}` }></div>
                        </div>
                        <div 
                            className={ `alipay pay_way` }
                            onClick={ () => {
                                this.setState({channel: 1});
                                this.storage.removeItem('user_channel');
                                this.storage.setItem('user_channel',1);
                            }}
                        >
                            <div className="img"></div>
                            <div className="name">支付宝支付</div>
                            <div className={`status ${this.state.channel === 1 ? 'active' : ''}`}></div>
                        </div>
                    </div>
                }
                <div className="rules">
                    <div onClick={agreementSelect} className={`agreement ${isAllowAgreement ? 'allow' : 'notAllow'}`}></div>
                    同意<a onClick={clickToAgreement} >《AirCourse用户支付协议》</a>
                </div>
                { courseId === '211' &&
                    <div className="text_wrap">
                        <p>说明</p>
                        <p>1、课程有效期为购课起365天。</p>
                        <p>2、课程一经购买不得退换、不得转课。</p>
                        <p>3、您可根据时间安排自行约课。</p>
                        <p>4、课程包含亲子互动实验套装一份，将于支付后1-7日内前按照您填写的收货地址为您寄出，所有材料均经过专业检测，可放心使用。</p>
                        <p>5、如有任何其他问题，请拨打客服热线：400-688-6057。</p>
                    </div>
                }
                { this.isMobile &&
                    <div className="btn_wrap" >
                        <div className="btn pay" onClick={() => {
                            let inviteAwardPackId = inviteAwardList.length ? inviteAwardList[inviteAwardIndex].inviteAwardPackId : null;
                            handleClick(coursesInfo.goodsNo, channel, inviteAwardPackId, isHaveEntity)
                        }}>立即支付</div>
                            <div className="price">￥{price - ~~price > 0 ? price.toFixed(2) : price}</div>
                    </div>
                }
                { !this.isMobile &&
                    <div className="btn_wrap" onClick={() => {
                        let inviteAwardPackId = inviteAwardList.length ? inviteAwardList[inviteAwardIndex].inviteAwardPackId : null;
                        handleClick(coursesInfo.goodsNo, channel, inviteAwardPackId, isHaveEntity)
                    }} >
                        <div className="btn pay" >立即支付</div>
                        <div className="price">{price - ~~price > 0 ? price.toFixed(2) : price}元</div>
                    </div>
                }
            </div>
        )
    }
}


export default NASAPay;



// WEBPACK FOOTER //
// ./src/template/NASAPay/NASAPay.jsx